import { eTaskStatus } from "../contracts/enums/status.enum";

export const TASKS_STATUS_OPTIONS: {id: number, text: string}[] = [
    {
        id: eTaskStatus.ALL,
        text: "Todos"
    },
    {
        id: eTaskStatus.PENDING,
        text: "A realizar"
    },
    {
        id: eTaskStatus.COMPLETED,
        text: "Concluídas"
    }
];